<template>
  <div>
    <v-autocomplete
      v-model="value.p"
      :items="pSentences"
      hide-no-data
      item-text="name"
      item-value="value"
      :label="$t('dangerousGoods.dangerousGoodsList.form.pSentences')"
      data-cy="pSentences"
      dense
      chips
      multiple
      @input="searchInput=null"
      :search-input.sync="searchInput">
    >
    </v-autocomplete>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: ["value"],
  components: {},
  data: () => ({ searchInput: null }),
  computed: {
    ...mapGetters(["pSentences"]),
  },
};
</script>
